import { render, staticRenderFns } from "./appItem.vue?vue&type=template&id=1304a746&scoped=true&"
import script from "./appItem.vue?vue&type=script&lang=js&"
export * from "./appItem.vue?vue&type=script&lang=js&"
import style0 from "./appItem.vue?vue&type=style&index=0&id=1304a746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304a746",
  null
  
)

export default component.exports